import React from "react";
import FooterLinkGroup from "./FooterLinkGroup";
import { automaticFooterColumns, managedFooterColumns } from "@/lib/publications/footerEditor";
import SocialProfileLinks from "./SocialProfileLinks";

export default function Footer({ siteSettings = {}, pages = [], categories = [], footerEditor }) {
  const siteName = siteSettings?.seo?.siteTitle || siteSettings?.organization?.name || "SURGEDOME";
  const columns = siteSettings.navigation?.footerManaged ? managedFooterColumns(siteSettings, pages, categories) : automaticFooterColumns(siteSettings, pages);
  return (
    <footer className="mt-12 w-full border-t border-gray-800 bg-[#0a0a0a] pb-6 pt-12 font-sans text-[#f8f6f1]">
      <div className="mx-auto flex max-w-[1400px] flex-col px-8 md:px-16 lg:px-32">
        <div className="mb-8 flex flex-col items-start justify-between gap-10 md:flex-row">
          <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-[14px] font-medium text-[#f8f6f1]/90 md:grid-cols-4">
            {columns.map((column, index) => (
              <div key={index} className="flex flex-col gap-2.5">
                <FooterLinkGroup items={column} position={"col" + (index + 1)} editor={footerEditor} className="space-y-2.5" linkClassName="transition-colors hover:text-gray-300" />
              </div>
            ))}
          </div>
          <div className="mt-12 flex w-full flex-col items-center md:mt-0 md:w-auto">
            <span className="mb-4 text-center text-[14px] font-bold">Follow Us:</span>
            <SocialProfileLinks profiles={siteSettings?.socialProfiles} className="flex flex-wrap justify-center gap-3" linkClassName="inline-flex min-w-8 h-8 items-center justify-center rounded-full bg-[#f8f6f1] px-2 text-xs font-bold text-[#0a0a0a] hover:bg-gray-200" />
          </div>
        </div>
        <div className="flex flex-col items-center justify-between gap-4 border-t border-[#333] pt-6 text-center md:flex-row md:text-left">
          <div className="flex items-center justify-center md:justify-start"><img src="/sarjik-signature.png" alt="Sarjik" className="h-4 w-auto brightness-0 invert" /></div>
          <div className="text-[13px] font-medium text-[#f8f6f1]/90">&copy; {new Date().getFullYear()} {siteName} Media. All Rights Reserved.</div>
        </div>
      </div>
    </footer>
  );
}
